import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges
} from "@angular/core";
import { BehaviorSubject, merge, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { IValidationRule } from "../IValidationRule";
import { ValidationRuleController } from "../ValidationRuleController";
import { NgClass, AsyncPipe } from "@angular/common";

@Component({
    selector: "rask-validation-message",
    styleUrls: ["./validation-message.component.scss"],
    templateUrl: "./validation-message.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgClass,
        AsyncPipe
    ]
})
export class ValidationMessageComponent implements OnInit, OnChanges {
    direct = false;

    @Input() for: any;
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("rule") validationRule: ValidationRuleController;

    protected hasErrors$: Observable<boolean>;

    private readonly hasErrorsSrc = new BehaviorSubject(false);

    ngOnInit() {
        if (this.validationRule != null) {
            const sources = this.validationRule.rules.map(r => r.changed);

            const hasRuleErrors$ = merge(...sources).pipe(
                map(res => !res.result)
            );

            this.hasErrors$ = merge(this.hasErrorsSrc, hasRuleErrors$);
        }

        if (this.for) {
            this.direct = true;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes.for || changes.for.firstChange) {
            return;
        }
        this.validateValue(changes.for.previousValue, changes.for.currentValue);
    }

    validateRules() {
        return this.validationRule.validate();
    }

    validateValue(oldValue, newValue) {
        const result = !this.validationRule.validateValue(oldValue, newValue);
        this.hasErrorsSrc.next(result);
    }

    invalid(rule: IValidationRule): boolean {
        return (rule.hasError || rule.hasWarning);
    }
}
